import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import eruda from 'eruda';

import { AppModule } from './app/app.module';
import { initLogger } from './app/core/logger';
import { environment } from './environments/environment';

// On-device debug console. Flip environment.erudaEnabled to true and
// rebuild when you need it.
if (environment.erudaEnabled) {
  eruda.init();
}

// Remote logging to Logflare with structured metadata (user, device, session).
initLogger();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
